export interface IStrings {
  add: string;
  addName: string;
  addSignature: string;
  addSupercard: string;
  addVehicle: string;
  addZip: string;
  alreadyCheckedIn: string;
  cancel: string;
  checkInCount1: string;
  checkInCount2: string;
  closeContactWithCovidLast14Days: string;
  couponsHeader: string;
  covidDisclaimer: string;
  covidEntryDenied: string;
  datOfBirthHeader: string;
  day: string;
  disclaimer: string;
  emailHeader: string;
  experiencedFluLikeSymptoms: string;
  firstname: string;
  goBack: string;
  home: string;
  homeReset: string;
  language: "eng" | "esp";
  languageHeader: string;
  lastname: string;
  make: string;
  maxYear: string;
  minYear: string;
  model: string;
  month: string;
  nameHeader: string;
  next: string;
  nextCouponGoal: string;
  noModels: string;
  noVehicle1: string;
  noVehicle2: string;
  optInHeader: string;
  pleaseSign: string;
  receiptCode: string;
  receiptCodeInstructions: string;
  rewardTextLan: string;
  select: string;
  signature: string;
  signatureAgreement: string;
  signatureAgreementButton: string;
  supercardHeader: string;
  tapBelow: string;
  thanksHeader: string;
  thanksHeaderVehicleTap: string;
  thanksCheckin: string;
  traveledLast14Days: string;
  typeBodyMan: string;
  typeFixingCar: string;
  typeMechanic: string;
  typeExporter: string;
  typeHeader: string;
  typeOwnGarage: string;
  typeOwnBodyShop: string;
  typeOwnCarLot: string;
  typeBuildCustomCars: string;
  update: string;
  vehicles: string;
  vehiclesHeader: string;
  wapaustincheckin: string;
  wapfacebookcheckin: string;
  welcomeBack: string;
  year: string;
  yes: string;
  zip: string;
  zipHeader: string;
  [key: string]: string;
}

export interface ILanguageStrings {
  eng: IStrings;
  esp: IStrings;
  [key: string]: IStrings;
}

export const strings: ILanguageStrings = {
  eng: {
    add: "Add",
    addName: "Add Name",
    addSignature: "Add Signature",
    addSupercard: "Add Supercard",
    addVehicle: "Add New Vehicle",
    addZip: "Add Zip",
    alreadyCheckedIn:
      "It looks like you already checked in today. Welcome back!",
    cancel: "Cancel",
    checkInCount1: "You've checked in ",
    checkInCount2: "times",
    closeContactWithCovidLast14Days:
      "Have you had close contact with or cared for someone diagnosed with COVID-19 within the last 14 days?",
    couponsHeader: "Coupons",
    covidDisclaimer:
      "In an effort to reduce the risk of COVID-19 exposure to employees, all visitors must complete the following screening questions:",
    covidEntryDenied:
      "Due to the CDC guidelines and for the safety of our team members and guests we are unable to grant you access to our facility at the moment. We appreciate your understanding and cooperation.",
    datOfBirthHeader: "Date of Birth",
    day: "Day",
    disclaimer:
      "By pressing Yes, you are signing up to receive automated text alerts from  an autodialer system. Consent to receive automated text alerts not required for purchase. Approx 9 msgs/mo. Msg &amp; Data Rates May Apply. Reply HELP for HELP, STOP to cancel.",
    emailHeader: "Please Enter Your Email:",
    experiencedFluLikeSymptoms:
      "Have you experienced any cold or flu-like symptoms in the last 14 days (fever, cough, shortness of breath or other respiratory problem)?",
    firstname: "First",
    goBack: "Go Back",
    home: "Finish Check-in",
    homeReset: "Cancel",
    language: "eng",
    languageHeader: "Please Choose Your Language:",
    lastname: "Last",
    make: "Make",
    maxYear: "Max Year",
    minYear: "Min Year",
    model: "Model",
    month: "Month",
    nameHeader: "Please Enter Your Name:",
    next: "Next/Finish",
    nextCouponGoal: "Next",
    noModels: "Sorry, No Models Found",
    noVehicle1: "It looks like you haven't added a vehicle yet.",
    noVehicle2:
      "Click 'Add New Vehicle' below to start receiving SMS notifications on your picks.",
    optInHeader:
      "Would you like to receive text messages notifying you of upcoming sales, specials and discounts?",
    pleaseSign: "Please Sign Below",
    receiptCode: "Receipt",
    receiptCodeInstructions: "Please Scan the barcode on your receipt",
    rewardTextLan: "You are %% check-ins away from a %% coupon!",
    select: "Select",
    signature: "Signature",
    signatureAgreement:
      "By pressing below, I acknowledge I have read, understand, and will comply with the above.",
    signatureAgreementButton: "I Accept",
    supercardHeader: "Please enter your Supercard Number:",
    tapBelow: "Tap one of the buttons below to update your profile",
    thanksCheckin: "Thanks for checking in!",
    thanksHeader: "Check In Complete!",
    thanksHeaderVehicleTap: "Thanks for adding your vehicles!",
    traveledLast14Days:
      "Have you traveled outside the country or been in close contact with anyone who has traveled outside the country within the last 14 days?",
    typeBodyMan: "I'm a body man",
    typeBuildCustomCars: "I build custom cars",
    typeExporter: "I'm an exporter",
    typeFixingCar: "I'm fixing my car",
    typeHeader: "Which type of customer are you?",
    typeMechanic: "I'm a mechanic",
    typeOwnBodyShop: "I own a body shop",
    typeOwnCarLot: "I own a car lot",
    typeOwnGarage: "I own a garage",
    update: "Update",
    vehicles: "Add Vehicle Picks",
    vehiclesHeader: "Receive Notices When These Vehicles Arrive in Inventory",
    wapaustincheckin: "You're Done! Please Move Forward. Thank you!",
    wapfacebookcheckin:
      "Check in on Facebook and get a free entry, just show cashier!",
    welcomeBack: "Welcome back! Please sign below",
    welcomeBackThanks: "Welcome back",
    welcomeBackThanksIf: "Welcome",
    welcomeThanks: "Welcome",
    welcomeThanksVehicleTap: "We will text you when your vehicle(s) arrive.",
    year: "Year",
    yes: "Yes",
    zip: "Zip",
    zipHeader: "Please Enter Your Zip:",
  },
  esp: {
    add: "Agregar",
    addName: "Agregar Nombre",
    addSignature: "Agregar Firma",
    addSupercard: "Agregar Supercard",
    addVehicle: "Agregar Vehículo",
    addZip: "Agregar Zip",
    alreadyCheckedIn: "Parece que ya te registraste. ¡Vuelve pronto!",
    cancel: "Cancelar",
    checkInCount1: "Has marcado ",
    checkInCount2: "veces",
    closeContactWithCovidLast14Days:
      "¿Ha tenido contacto cercano o cuidado a alguien diagnosticado con COVID-19 en los últimos 14 días?",
    couponsHeader: "Cupones",
    covidDisclaimer:
      "En un esfuerzo por reducir el riesgo de exposición de COVID-19 a los empleados, todos los visitantes deben completar las siguientes preguntas de detección:",
    covidEntryDenied:
      "Debido a las pautas de los CDC y por la seguridad de los miembros de nuestro equipo e invitados, no podemos otorgarle acceso a nuestras instalaciones en este momento. Agradecemos su comprensión y cooperación",
    datOfBirthHeader: "Fecha de Nacimiento",
    day: "Día",
    disclaimer:
      " Presionando si, te estás inscribiendo para recibir alertas automáticas de texto de un Sistema de marcado automático. El consentimiento para recibir alertas automáticas de texto no es necesario para compra. Aproximadamente 9 mensajes / mes. Se pueden aplicar tarifas de mensajes y datos. Responde a la ayuda por ayuda, deja de cancelar. ",
    emailHeader: "Por Favor, Escriba Su Email:",
    experiencedFluLikeSymptoms:
      "¿Ha experimentado algún síntoma de resfriado o gripe en los últimos 14 días (fiebre, tos, falta de aire u otro problema respiratorio)?",
    firstname: "Nombre",
    goBack: "Atrás",
    home: "Completar Registro",
    homeReset: "Cancelar",
    language: "esp",
    languageHeader: "Por favor elija su idioma:",
    lastname: "Appelido",
    make: "Marca",
    maxYear: "Año Max",
    minYear: "Año Min",
    model: "Modelo",
    month: "Mes",
    nameHeader: "Por Favor, Escriba Su Nombre:",
    next: "Siguiente",
    nextCouponGoal: "Siguiente",
    noModels: "Lo sentimos, no se encontraron modelos",
    noVehicle1: "Parece que aún no has agregado un vehículo.",
    noVehicle2:
      "Haga clic en 'Agregar vehículo nuevo' a continuación para comenzar a recibir notificaciones por SMS sobre sus selecciones.",
    optInHeader:
      "¿Le gustaría recibir mensajes de texto que le informen sobre próximas ventas, ofertas especiales y descuentos?",
    pleaseSign: "Por Favor Firme Abajo",
    receiptCode: "Recibo",
    receiptCodeInstructions:
      "Por favor escanee el código de barras en su recibo",
    rewardTextLan: "Estás a %%  registros de distancia de %% en el cupón!",
    select: "Seleccionar",
    signature: "Firma",
    signatureAgreement:
      "Al presionar a continuación, reconozco que he leído, entiendo y cumpliré con lo anterior.",
    signatureAgreementButton: "Acepto",
    supercardHeader: "Ingrese su número de Supercard:",
    tapBelow:
      "Toca uno de los botones a continuación para actualizar tu perfil",
    thanksCheckin: "¡Gracias por registrarte!",
    thanksHeader: "Registro completo!",
    thanksHeaderVehicleTap: "¡Gracias por agregar sus vehículos!",
    traveledLast14Days:
      "¿Ha viajado fuera del país o ha estado en contacto cercano con alguien que haya viajado fuera del país en los últimos 14 días?",
    typeBodyMan: "Soy un hombre de cuerpo",
    typeBuildCustomCars: "Yo construimos autos personalizados",
    typeExporter: "Soy exportador",
    typeFixingCar: "Estoy arreglando mi auto",
    typeHeader: "¿Qué tipo de cliente eres?",
    typeMechanic: "Soy mecanico",
    typeOwnBodyShop: "Yo dueños de un taller de carrocería",
    typeOwnCarLot: "Yo poseemos un lote de autos",
    typeOwnGarage: "Yo poseemos un garaje",
    update: "Actualicar",
    vehicles: "Vehículos",
    vehiclesHeader:
      "Recibir Avisos Cuando Estos Vehículos Lleguen al Inventario",
    wapaustincheckin: "¡Ya terminaste! Por favor, avance. ¡Gracias!",
    wapfacebookcheckin:
      "Registrese en Facebook para entrar GRATIS y muestre al cajero.",
    welcomeBack: "¡Gracias por regresar! Por Favor Firme Abajo",
    welcomeBackThanks: "Bienvenidos de nuevo",
    welcomeBackThanksIf: "Bienvenidas",
    welcomeThanks: "Bienvenidos",
    welcomeThanksVehicleTap: "Le enviaremos un mensaje de texto cuando lleguen sus vehículos.",
    year: "Año",
    yes: "Si",
    zip: "Código Postal",
    zipHeader: "Por Favor Proporcione Su Código Postal:",
  },
};



// WEBPACK FOOTER //
// ./src/store/reducers/strings.ts